import Account from '@/pages/Account'


export default {
  path: '/account',
  component: Account,
  children: [
    // {
    //   path: 'createcc',
    //   name: 'CreateSellpoint',
    //   component: CreateSellpoint
    // },
  ]
}



// WEBPACK FOOTER //
// ./src/router/account.js